import { createSelector } from '@reduxjs/toolkit';
import { selectEntities, selectForDevice } from './entitiesSlice';
import { panelGroups } from '../features/panel_groups/panelGroupsSlice';
import { panelDevicesInGroup } from '../features/panel_devices/panelDevicesSlice';
export const selectEntitiesForPanel = createSelector([selectEntities,
    (state, pid) => panelGroups(state.definitions.panel_groups, pid),
    (state, _) => state.definitions.panel_devices
], (entities, groups, panelDevices) => {
    const res = [];
    for (const g of groups) {
        const groupPanelDevices = panelDevicesInGroup(panelDevices, g.id);
        for (const panelDevice of groupPanelDevices) {
            const es = selectForDevice(entities, panelDevice.device_id);
            for (const e of es) {
                res.push(e);
            }
        }
    }
    return res;
});
